import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import { FeedBeek as ListFeedBeek } from '../../../components/ResultDiagnosis/FeedBeek'
import { HeaderResult } from '../../../components/ResultDiagnosis/Headerresult'
import { ResultFooter } from '../../../components/ResultDiagnosis/ResultFooter'
import { Trail } from '../../../components/ResultDiagnosis/Trail'
import useApi from '../../../hooks/useApi'

import { OscLoggedLayout } from '../../../layout/OscLoggedLayout'
import { OscDiagnosisResult } from '../../../types/OscDiagnosisResult'
import { Question } from '../../../types/Question'
import bg from '../../../assets/Vector 8.svg'


export const ResultDiagnosis = () => {
    const api = useApi()
    const { id } = useParams<any>();

    const [result, setResult] = useState<OscDiagnosisResult>()
    const [feedBeek,setFeedBeck] = useState<Question[]>([])
 
    const loadResult = useCallback(async () => {
        await api.get(`/client/diagnoses/${id}/result`).then(res => {
            setResult(res.data)
        }).catch(console.log)
    }, [api, id])

    const loadFeedBeek = useCallback(async () => {
        await api.get(`/client/diagnoses/${id}/feedbeek`).then(res => {
            setFeedBeck(res.data)
        }).catch(console.log)
    }, [api, id])

    const data = useMemo(():{my_score:string,avarege:string}=>{
        let total=0
        let avarega =0
        let score = 0

        if(result?.diagnosis.total)
        total = result.diagnosis.total;

        if(result?.diagnosis.average)
        avarega = result.diagnosis.average

        let avg = (((100*avarega)/total)/10)*1

        if(result?.diagnosis.score)
         score = result.diagnosis.score
        let scr = (((100*score)/total)/10)*1

        return {
            my_score:scr.toFixed(1),
            avarege:avg.toFixed(1)
        }
        
       
    },[result])

    useEffect(() => {
        loadResult()
        loadFeedBeek()
    }, [loadResult,loadFeedBeek])

    return (
        <OscLoggedLayout>
            <div className='grid grid-cols-10 mb-10'>
                <div className='col-span-7'>
                    <HeaderResult
                        text={result?.diagnosis.name ? "" + result.diagnosis.name : "0"}
                        myNote={data.my_score}
                        avg={data.avarege}
                    />
                </div>
                <div className='col-span-3 w-full flex-col justify-center items-center' style={{
                    backgroundImage:`url("${bg}")`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "auto auto",
                    backgroundPosition: "center"
                }}>
                     <ResultFooter />
                </div>
            </div>
             <ListFeedBeek feedBeek={feedBeek} /> 
             <Trail feedbeek={feedBeek} />
            
        </OscLoggedLayout>
    )
}